"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Input = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var input_style_1 = require("./input-style");
var input_type_1 = require("./input-type");
function Input(props) {
    var _a = props.type, type = _a === void 0 ? input_type_1.InputType.TEXT : _a;
    return (0, jsx_runtime_1.jsx)(input_style_1.StyledInput, __assign({}, props, { type: type }));
}
exports.Input = Input;
